import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/Carousel';
export function NewsSection() {
  const news = [{
    id: 'kafaa',
    title: 'Tourisme : le programme "Kafaa" vise à certifier 7.550 professionnels d\'ici 2026 (Mme Ammor)',
    excerpt: 'Rabat - Le programme "Kafaa" de validation des acquis de l\'expérience (VAE) a pour objectif de certifier 7.550 professionnels...',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076&auto=format&fit=crop'
  }, {
    id: 'maroc-destination',
    title: 'Le Maroc se consolide comme « une destination leader du tourisme mondial », selon une revue argentine',
    excerpt: 'Buenos Aires - Le Maroc se positionne comme « une destination leader du tourisme mondial » après avoir battu le record...',
    image: 'https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?q=80&w=2067&auto=format&fit=crop'
  }, {
    id: 'tourisme-inclusif',
    title: 'Le tourisme inclusif, un élément clé pour le développement de toutes les régions du Maroc (Mme Ammor)',
    excerpt: 'Casablanca - Le tourisme inclusif constitue un "élément clé" pour le développement et l\'intégration de toutes les régions marocaines...',
    image: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'ryanair',
    title: 'ONMT/Ryanair: Lancement à partir de janvier prochain de deux lignes aériennes directes reliant Dakhla à Madrid et Lanzarote',
    excerpt: "Dakhla - L'Office National Marocain du Tourisme (ONMT) et la compagnie aérienne Ryanair ont signé, mercredi...",
    image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=2074&auto=format&fit=crop'
  }, {
    id: 'wtm-londres',
    title: 'Tourisme : Le Maroc sacré "destination la plus accueillante" au WTM de Londres',
    excerpt: 'Londres - L\'Office national marocain du tourisme (ONMT) a reçu, mardi soir, le prix de la "Destination la plus accueillante"...',
    image: 'https://images.unsplash.com/photo-1569025690938-a00729c9e1f9?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'royal-air-maroc',
    title: 'Aéroport Mohammed V de Casablanca : Royal Air Maroc réceptionne son dixième Boeing 787-9 Dreamliner',
    excerpt: "Casablanca - Royal Air Maroc (RAM) annonce avoir réceptionné, dimanche à l'aéroport Mohammed V de Casablanca, son dixième...",
    image: 'https://images.unsplash.com/photo-1464037866556-6812c9d1c72e?q=80&w=2070&auto=format&fit=crop'
  }];
  return <section id="news" className="bg-arih-light-bg py-[120px]" data-id="element-184">
      <div className="container mx-auto px-4 md:px-8" data-id="element-185">
        <Carousel opts={{
        align: 'start',
        loop: true
      }} className="w-full" data-id="element-186">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-187">
            <div className="max-w-3xl" data-id="element-188">
              <h2 className="text-[36px] md:text-[48px] font-bold text-arih-dark leading-tight mb-4" data-id="element-189">
                Actualités à la une
              </h2>
              <p className="text-[18px] text-arih-gray leading-[28.8px] whitespace-pre-line" data-id="element-190">
                {"Suivez les actualités nationales du secteur : événements,\ninitiatives, tendances et évolutions qui impactent l'industrie."}
              </p>
            </div>
            <div className="flex gap-2" data-id="element-191">
              <CarouselPrevious className="relative inset-0 translate-y-0 h-12 w-12 bg-white hover:bg-gray-100 border border-gray-200 text-arih-dark shadow-sm" data-id="element-192" />
              <CarouselNext className="relative inset-0 translate-y-0 h-12 w-12 bg-white hover:bg-gray-100 border border-gray-200 text-arih-dark shadow-sm" data-id="element-193" />
            </div>
          </div>

          <CarouselContent className="-ml-4 md:-ml-6" data-id="element-194">
            {news.map((item, index) => <CarouselItem key={index} className="pl-4 md:pl-6 md:basis-1/2" data-id="element-195">
                <a href={`/news/${item.id}`} className="block" data-id="element-196">
                  <Card className="border-0 shadow-none bg-transparent group cursor-pointer" data-id="element-197">
                    <CardContent className="p-0" data-id="element-198">
                      <div className="overflow-hidden rounded-xl mb-6" data-id="element-199">
                        <img src={item.image} alt={item.title} className="w-full h-[300px] md:h-[450px] object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-200" />
                      </div>
                      <h3 className="text-[24px] font-bold text-arih-dark mb-3 group-hover:text-arih-blue transition-colors" data-id="element-201">
                        {item.title}
                      </h3>
                      <p className="text-[18px] text-arih-gray leading-[28.8px]" data-id="element-202">
                        {item.excerpt}
                      </p>
                    </CardContent>
                  </Card>
                </a>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}